import { useNavigate, useLocation } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();
  let query = useLocation().search;

  return (route: string | number, remove = false) => {
    if (typeof route === 'number') return navigate(route);
    const queryIndex = route.indexOf('?');

    if (query.includes('?') && queryIndex > -1 && !remove) {
      query += `&${route.slice(queryIndex + 1)}`;
      route = route.slice(0, queryIndex);
    }

    navigate(`${route}${(!remove && query) || ''}`);
  };
};
